<template>
  <div v-if="offer">
    <!-- Accepted Offer -->
    <div v-if="offer.status == 1" class="d-flex flex-row">
      <div class="offer-status offer-status-accepted">
        <i class="mdi mdi-check-circle"></i>
        {{ $t("ecommerce.product.acceptedOffers") }}
        
        <router-link 
          v-if="product.has_been_sold !== 1" 
          :to="{
            name: 'checkoutOrder',
            params: { id: offer.id, type: 'offer' },
          }" 
          class="btn btn-success"
        >
          {{ $t('ecommerce.check-out') }}
        </router-link>
        
        <button v-else disabled class="offer-status offer-status-accepted">
          <i class="mdi mdi-check-circle"></i>
          {{ $t("sentence.sold") }}
        </button>
      </div>
    </div>

    <!-- Refused or Pending Offer -->
    <div v-else class="d-flex flex-row">
      <!-- Refused Offer -->
      <div v-if="offer.status == 0" class="offer-status offer-status-refused">
        <i class="mdi mdi-close-circle"></i>
        {{ $t("ecommerce.product.refusedOffers") }}
        
        <button 
          v-if="offer.status !== 1" 
          class="btn btn-danger" 
          @click="$emit('make-offer', product)"
        >
          {{ $t('ecommerce.newOffer') }}
        </button>
      </div>

      <!-- Pending/No Response Offer -->
      <div v-else class="offer-status-indicator status-outbid">
        <i class="mdi mdi-timer"></i>
        {{ $t("ecommerce.product.noResponseOffers") }}
        
        <button 
          v-if="offer.status !== 1" 
          class="btn btn-warning" 
          @click="$emit('make-offer', product)"
        >
          {{ $t('ecommerce.newOffer') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserOfferStatusComp",
  
  props: {
    offer: {
      type: Object,
      default: null
    },
    product: {
      type: Object,
      required: true
    }
  },
  
  emits: ['make-offer']
};
</script>

<style scoped>
.offer-status-indicator {
  margin-top: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

.offer-status-indicator i {
  font-size: 16px;
}


</style>